import { h } from 'preact'

/**
 * Safe i18n lookup — returns null when the key is missing instead of the
 * "[missing ..." string that i18n-js emits.
 */
export function safeT(i18n, key) {
  if (!i18n) return null
  const result = i18n.t(key)
  if (typeof result !== 'string' || result.startsWith('[missing')) return null
  return result
}

/**
 * Resolve a status { code, text } to a human-readable label.
 * Priority: pre-translated text → ai.status.{code} → ai.codes.{code} → code itself
 */
export function statusLabel(status, i18n, fallback) {
  if (!status) return fallback || ''
  if (status.text && !status.text.startsWith('[missing')) return status.text
  if (status.code) {
    return safeT(i18n, `ai.status.${status.code}`)
      ?? safeT(i18n, `ai.codes.${status.code}`)
      ?? fallback
      // No raw code fallback — unknown codes silently use the fallback
  }
  return fallback || ''
}

/**
 * ActivityIndicator — spinner with dynamic status text inside the streaming AI bubble.
 * Props: { i18n, status }
 * status: { code, text } | null — current processing status; overrides default label when set
 */
export function ActivityIndicator({ i18n, status }) {
  const defaultLabel = safeT(i18n, 'ai.activity.still_working') || 'Még dolgozom...'
  const label = statusLabel(status, i18n, defaultLabel)

  return (
    <div class="activity-indicator d-flex align-items-center text-muted py-2">
      <div class="spinner-border spinner-border-sm me-2" role="status" style="width:1rem;height:1rem;">
        <span class="visually-hidden">Loading...</span>
      </div>
      <span class="activity-text">{label}</span>
    </div>
  )
}
